import { useFormik } from "formik"
import SimpleBar from "simplebar-react"
import {
  acceptRejectAdvRfqPayment,
  approveRfqPaymentRequest,
  approveRfqDocsAfterCompletion,
  getListRequestAdvanceRfqPayment,
  getRfqAndVendorBidRfq,
  getRfqDetail,
  getRfqPaymentMilestones,
  getRfqQuotesDetail,
  milestoneStatusByAdmin,
  renegotiateVendorBidRfq,
  rfqExtraWork,
  rfqMilestoneExtraWork,
  rfqMilestonePayment,
  rfqRejectedByVendorlist,
  rfqTaskMilestoneDpdw,
  updateMilestones,
  updateRfqAdvancedPaymentAndSecurityDeposit,
  vendorBidRfq,
  verifyRfqTaskDocs,
} from "helpers/fakebackend_helper"
import { parseInt } from "lodash"
import React, { useEffect, useMemo, useState } from "react"
import { useNavigate, useParams, Link } from "react-router-dom"
import Select from "react-select"
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  FormFeedback,
  FormGroup,
  Form,
  Alert,
  CardHeader,
} from "reactstrap"
import Swal from "sweetalert2"
import * as Yup from "yup"
import formatNumberWithCommas from "components/Common/formatNumberWithCommas"
import {
  getStatusBadgeClassOfMainRFQ,
  getStatusBadgeClassOfRFQMilestone,
} from "components/Common/handleStatusColorOfRFQ"

const ViewRfqQuotes = () => {
  const [invoice, setInvoice] = useState({})
  const [showAllVendors, setShowAllVendors] = useState(true)
  const [modal, setModal] = useState(false)
  const [negotiationAmount, setNegotiationAmount] = useState("")
  const [negotiationDeadLine, setNegotiationDeadLine] = useState("")
  const [selectedVendor, setSelectedVendor] = useState(null)
  const [vendorBidDetails, setVendorBidDetails] = useState([])
  const { id } = useParams()
  const [isOpen1, setIsOpen1] = useState([])
  const [documents, setDocuments] = useState([])
  const [pics, setPics] =useState([])
  const [info, setInfo] = useState({})
  const [milestoneId, setMilestoneId] = useState("")
  const [taskId, setTaskId] = useState("")
  const [isAddMilestone, setIsAddMilestone] = useState("")
  const [tasks1, setTasks1] = useState([
    { task: "", document_required: "", estimated_completion_date: "" },
  ])
  const [selectedMilestoneAmt, setSelectedMilestoneAmt] = useState("")
  const [milestoneOptions, setMilestoneOptions] = useState([])
  const toggleModal = vendor => {
    setSelectedVendor(vendor)
    setModal(!modal)
  }
  document.title = "RFQ Details"

  const [modalType, setModalType] = useState(null)
  const changeModal = (type = null) => setModalType(type)
    const [permission] = useState(JSON.parse(localStorage.getItem("permission")))
    /*console.log("permission", permission)*/
  /*
  const submitNegotiation = async () => {
    console.log(
      "Negotiation amount for",
      selectedVendor?.name,
      "is",
      negotiationAmount
    )
    const data = {
      is_rfq_vendor_bid_accepted: 0,
      negotiation_cost: negotiationAmount,
      vendor_id: selectedVendor?.id,
      negotiate_end_date: negotiationDeadLine
    }
    //loading start
    const loadingSwal = Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      showConfirmButton: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      },
    })
    const response = await renegotiateVendorBidRfq(selectedVendor?.id, data)
    if (response && response.status === true) {
      //loading false
      loadingSwal.close()
      Swal.fire({
        title: "Success",
        icon: "success",
        text: "Bid negotiated successfully",
      })
      fetchRfqQuotesDetail()
    } else {
      loadingSwal.close()
      Swal.fire({
        title: "Failure",
        icon: "error",
        text: "Bid could not be negotiated",
      })
    }
    setModal(false)
    setNegotiationAmount("")
  }*/

  const acceptNegotiation = async (
    id,
    negotiation_cost,
    total_invoice_amount,
    vendor_id
  ) => {
    console.log("Negotiation amount is", negotiation_cost)
    let data = {}
    if (negotiation_cost === null) {
      data = {
        is_rfq_vendor_bid_accepted: 1,
        negotiation_cost: total_invoice_amount,
        vendor_id: vendor_id,
      }
    } else {
      data = {
        is_rfq_vendor_bid_accepted: 1,
        negotiation_cost: negotiation_cost,
        vendor_id: vendor_id,
      }
    }
    console.log("Data to be sent", data)
    //loading start
    const loadingSwal = Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      showConfirmButton: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      },
    })
    const response = await renegotiateVendorBidRfq(id, data)
    if (response && response.status === true) {
      //loading false
      loadingSwal.close()
      Swal.fire({
        title: "Success",
        icon: "success",
        text: "Bid accepted",
      })
      fetchRfqQuotesDetail()
      fetchRfqDetail()
      fetchVendorBidRfq()
    } else {
      loadingSwal.close()
      Swal.fire({
        title: "Failure",
        icon: "error",
        text: "Bid could not be accepted",
      })
    }
    fetchRfqQuotesDetail()
    fetchRfqDetail()
    fetchVendorBidRfq()
    setNegotiationAmount("")
  }
  const [rfqDetail, setRfqDetail] = useState([])
  const [rfqLogs, setRfqLogs] = useState([])
  const [item, setItem] = useState([])
  // Define and execute data fetching functions
  const fetchRfqDetail = async () => {
    try {
      const response = await getRfqDetail(id)
      setRfqDetail(response.data)
      setRfqLogs(response.rfq_logs)
    } catch (error) {
      console.error("Error fetching rfq:", error)
    }
  }
  const fetchMilestoneList = async () => {
    try {
      const response = await rfqTaskMilestoneDpdw(id)
      setMilestoneOptions(response.data)
    } catch (error) {
      console.error("Error fetching rfq:", error)
    }
  }

  useEffect(() => {
    // Call both fetch functions
    fetchMilestoneList()
    fetchRfqDetail()
  }, [id])

  console.log("rqdetails", rfqDetail)
  const [paymentMilestones, setPaymentMilestones] = useState([])
  const fetchVendorBidRfq = async () => {
    try {
      const response = await getRfqAndVendorBidRfq(id)
      setVendorBidDetails(response.data[0])
    } catch (error) {
      console.error("Error fetching rfq:", error)
    }
  }
  const fetchRfqPayementMilestones = async () => {
    try {
      const response = await getRfqPaymentMilestones(id)
      if (response && response.status === true) {
        console.log("response.data", response.data)
        setPaymentMilestones(response.data)
      } else {
        console.log("Error fetching data")
      }
    } catch (error) {
      console.error("Error fetching rfq:", error)
    }
  }
  useEffect(() => {
    // Call both fetch functions
    fetchRfqPayementMilestones()
  }, [id])
  console.log("payment milestones", paymentMilestones[0]?.id, "isopen", isOpen1)

  const [vendorsRejected, setVendorsRejected] = useState({})
  const fetchRfqRejectedByVendor = async () => {
    try {
      const response = await rfqRejectedByVendorlist(id)
      setVendorsRejected(response.data)
    } catch (error) {
      console.error("Error fetching rfq:", error)
    }
  }

  const fetchRfqQuotesDetail = async () => {
    try {
      const response = await getRfqQuotesDetail(id)
      setRfqQuotesDetail(response.data)
    } catch (error) {
      console.error("Error fetching rfq:", error)
    }
  }

  const [paymentDetails, setPaymentDetails] = useState([{milestone_title:null, amount_requested:null, requested_date:null, request_advance_desc:null, status:null, paid_amount:null, reject_advance_desc:null}])
  const fetchAdvanceRfqPayment = async () => {
    try {
      const response = await getListRequestAdvanceRfqPayment(id)
      setPaymentDetails(response.data)
    } catch (error) {
      console.error("Error fetching rfq:", error)
    }
  }

  const handleApprovePaymentRequest = async (paymentItem) => {
    try {
      const response = await approveRfqPaymentRequest({
        rfq_payment_id: paymentItem.id,
        rfq_id: id,
        vendor_id: rfqDetail.assigned_vendor_id,
      })
      if (response.status === true) {
        Swal.fire({ title: "Success", icon: "success", text: "Payment request approved" })
        fetchAdvanceRfqPayment()
      } else {
        Swal.fire({ title: "Failure", icon: "error", text: "Could not approve payment request" })
      }
    } catch (error) {
      Swal.fire({ icon: "error", title: "Error", text: error?.response?.data?.message || "An unexpected error occurred." })
    }
  }

  useEffect(() => {
    fetchVendorBidRfq()
    fetchAdvanceRfqPayment()
  }, [id])

  // Payment Details Validation Schema
  const paymentDetailsValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      security_deposit_amount: "",
      advance_payment_amount: "",
    },
    validationSchema: Yup.object({
      security_deposit_amount: Yup.number()
        .typeError("Must be a number")
        .required("Security Deposit Amount is required")
        .positive("Must be positive"),
      advance_payment_amount: Yup.number()
        .typeError("Must be a number")
        .max(
          rfqDetail.total_final_amount,
          `Must be less than ${rfqDetail.total_final_amount}`
        )
        .required("Advance Payment Amount is required")
        .positive("Must be positive"),
    }),
    onSubmit: async (values, { resetForm }) => {
      console.log("Payment Details:", values)
      const newValues = { ...values, vendor_id: rfqDetail.assigned_vendor_id }
      //loading start
      const loadingSwal = Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading()
        },
      })
      try {
        const response = await updateRfqAdvancedPaymentAndSecurityDeposit(
          id,
          newValues
        )
        if (response && response.status === true) {
          //loading false
          fetchRfqDetail()
          loadingSwal.close()
          Swal.fire({
            title: "Success",
            icon: "success",
            text: "Payment Details added successfully",
          })
        } else {
          loadingSwal.close()
          Swal.fire({
            title: "Failure",
            icon: "error",
            text: "Payment Details could not be saved",
          })
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error?.response?.data?.message || "An unexpected error occurred.",
        })
      }
      setModalType(null)
      resetForm()
      window.location.reload()
    },
  })
  const addPaymentValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      rfq_id: id,
      vendor_id:rfqDetail.assigned_vendor_id,
      paid_amount:"",
      milestone_amount:"",
      milestone_id:"",
      payment_date: new Date().toISOString().split("T")[0],
      request_advance_desc:""
    },
    validationSchema: Yup.object({
      request_advance_desc: Yup.string().required("Please enter a description"),
      paid_amount: Yup.number()
          .typeError("Must be a number")
          .required("Payment Amount is required")
          .min(0, "Payment Amount can not be negative"),
      payment_date:Yup.date().required("Please enter a date")
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const loadingSwal = Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
        const response = await rfqMilestonePayment(values)
        if (response.status === true) {
          loadingSwal.close()
          Swal.fire({
            title: "Success",
            icon: "success",
            text: "Payment was successful",
          })
          fetchRfqPayementMilestones()
          fetchAdvanceRfqPayment()
          fetchMilestoneList()
          fetchRfqDetail()
          resetForm()
        } else {
          loadingSwal.close()
          Swal.fire({
            title: "Failure",
            icon: "error",
            text: "Payment was unsuccessful",
          })
        }
        setModalType(null)
      } catch (error) {
        loadingSwal.close()
        console.error("Error occurred:", error)
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error?.response?.data?.message || "An unexpected error occurred.",
        })
      }
      fetchAdvanceRfqPayment()
      fetchRfqDetail()
      fetchMilestoneList()
    },
  })

  const acceptPaymentValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      rfq_id: id,
      vendor_id: rfqDetail.assigned_vendor_id,
      rfq_payment_id: item?.id,
      rfq_invoice_no: item?.invoice_no,
      milestone_id: item?.milestone_id,
      status:"paid",
      payment_date: new Date().toISOString().split("T")[0],
      paid_amount: item?.amount_requested ?? ""
    },
    validationSchema: Yup.object({
      paid_amount: Yup.number().typeError("Must be a number")
              .required("Payment Amount is required")
              .positive("Must be positive"),
      payment_date:Yup.date().required("Please enter a date")
    }),
    onSubmit: async values => {
      try {
        const response = await acceptRejectAdvRfqPayment(values)
        if (response.status === true) {
          Swal.fire({
            title: "Success",
            icon: "success",
            text: "Advance Payment Request was accepted",
          })
          fetchAdvanceRfqPayment()
          fetchRfqDetail()
          fetchMilestoneList()
        } else {
          Swal.fire({
            title: "Failure",
            icon: "error",
            text: "Advance Payment Request could not be accepted",
          })
        }
        setModalType(null)
      } catch (error) {
        console.error("Error accepting Advance Payment Request:", error)
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error?.response?.data?.message || "An unexpected error occurred.",
        })
      }
      fetchAdvanceRfqPayment()
      fetchRfqDetail()
      fetchMilestoneList()
    },
  })
  const advPaymentRejectionValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      rfq_id: id,
      vendor_id: rfqDetail.assigned_vendor_id,
      rfq_payment_id: item?.id,
      rfq_invoice_no: item?.invoice_no,
      milestone_id: item?.milestone_id,
      status: "rejected",
      reject_advance_desc: "",
    },
    validationSchema: Yup.object({
      reject_advance_desc: Yup.string().required("Please enter a reason"),
    }),
    onSubmit: async values => {
      try {
        const response = await acceptRejectAdvRfqPayment(values)
        if (response.status === true) {
          Swal.fire({
            title: "Success",
            icon: "success",
            text: "Advance Payment Request was rejected",
          })
          fetchAdvanceRfqPayment()
        } else {
          Swal.fire({
            title: "Failure",
            icon: "error",
            text: "Advance Payment Request could not be rejected",
          })
        }
        setModalType(null)
      } catch (error) {
        console.error("Error rejecting Advance Payment Request:", error)
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error?.response?.data?.message || "An unexpected error occurred.",
        })
      }
    },
  })
  const addTaskValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      rfq_id: id,
      milestone_id: milestoneId,
      vendor_id: rfqDetail.assigned_vendor_id,
      tasks: "",
    },
    validationSchema: null,
    onSubmit: async values => {
      try {
        const response = await rfqExtraWork(values)
        if (response.status === true) {
          Swal.fire({
            title: "Success",
            icon: "success",
            text: "Tasks were added successfully",
          })
          fetchAdvanceRfqPayment()
          fetchRfqDetail()
          fetchRfqPayementMilestones()
        } else {
          Swal.fire({
            title: "Failure",
            icon: "error",
            text: "Tasks could not be added",
          })
        }
        setModalType(null)
      } catch (error) {
        console.error("Error adding Tasks:", error)
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error?.response?.data?.message || "An unexpected error occurred.",
        })
      }
      setTasks1([{ task: "", document_required: "", estimated_completion_date: "" }])
      fetchRfqPayementMilestones()
    },
  })

  const reworkValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      status: "rejected",
      rework_reason: "",
      vendor_id: rfqDetail.assigned_vendor_id,
      rfq_id: id,
    },
    validationSchema: Yup.object({
      rework_reason: Yup.string().required("Please enter a rework reason"),
    }),
    onSubmit: async values => {
      console.log("Rework Description:", values)
      const loadingSwal = Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      const response = await verifyRfqTaskDocs(taskId, values)
      if (response.status === true) {
        loadingSwal.close()
        Swal.fire({
          title: "Success",
          icon: "success",
          text: "Rework reason added successfully",
        })
        fetchRfqDetail()
        fetchRfqPayementMilestones()
      } else {
        loadingSwal.close()
        Swal.fire({
          title: "Failure",
          icon: "error",
          text: "Rework reason could not be added",
        })
      }
      setModalType(null)
    },
  })

  const negotiateValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      is_rfq_vendor_bid_accepted: 0,
      negotiation_cost: "",
      vendor_id: selectedVendor?.vendor_id,
      negotiate_end_date: "",
    },
    // validationSchema: Yup.object({
    //   negotiation_cost: Yup.number()
    //     .required("Please enter an amount")
    //     .min(0, "Amount can not be negative"),
    //     negotiate_end_date: Yup.date().required("Please enter a date")//.min(new Date().toISOString().split("T")[0])
    // }),
    onSubmit: async values => {
      try {
        console.log(
          "Negotiation amount for",
          selectedVendor?.name,
          "is",
          negotiationAmount
        )
        //loading start
        const loadingSwal = Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
        const response = await renegotiateVendorBidRfq(
          selectedVendor?.id,
          values
        )
        if (response && response.status === true) {
          //loading false
          loadingSwal.close()
          Swal.fire({
            title: "Success",
            icon: "success",
            text: "Bid negotiated successfully",
          })
          fetchRfqQuotesDetail()
        } else {
          loadingSwal.close()
          Swal.fire({
            title: "Failure",
            icon: "error",
            text: "Bid could not be negotiated",
          })
        }
        setModal(false)
        setNegotiationAmount("")
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error?.response?.data?.message || "An unexpected error occurred.",
        })
      }

      setModalType(null)
    },
  })
  console.log("add payment Validation", addPaymentValidation)
  const closeValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      status: 13,
      paid_amount: "",
      // final_remaining_amount: rfqDetail.new_final_remaining_amount,
    },
    validationSchema: Yup.object({}),

    onSubmit: async values => {
      try {
        const newValues = { ...values, vendor_id: rfqDetail.assigned_vendor_id }

        const response = await approveRfqDocsAfterCompletion(id, newValues)
        if (response.status === true) {
          Swal.fire({
            title: "Success",
            icon: "success",
            text: "Status changed to closed successfully",
          })
          fetchRfqDetail()
        } else {
          Swal.fire({
            title: "Failure",
            icon: "error",
            text: "Status could not be changed to closed",
          })
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error?.response?.data?.message || "An unexpected error occurred.",
        })
      }

      setModalType(null)
    },
  })

  const [rfqQuotesDetail, setRfqQuotesDetail] = useState([])
  useEffect(() => {
    // Call both fetch functions
    fetchRfqQuotesDetail()
    fetchRfqRejectedByVendor()
  }, [id])
  const tasks = rfqDetail.tasks
  console.log(tasks)
  // const displayedVendors = showAllVendors
  //   ? rfqQuotesDetail
  //   : rfqQuotesDetail.slice(0, 3)

  const displayedVendors = rfqQuotesDetail.filter(
    vendor => vendor.brand_name !== null
  )

  const estimated_date_null =
    tasks?.every(task => task.estimated_completion_date !== null) || false
  const status_null = tasks?.every(task => task.status !== null) || false
  const work_start_null =
    tasks?.every(task => task.work_start !== null) || false
  const check = tasks?.some(
    task =>
      (task.status === "rejected" || task.status === "approved") &&
      task.status !== "completed"
  )
  const allMilestoneApproved = paymentMilestones?.every(ms => ms.milestone_status === "Approved")
  const allMilestonePaid = paymentMilestones?.every(ms => ms.milestone_payment_status==="Paid")
  const everyInvoicePresent = paymentMilestones?.every(ms => ms.invoice !== null)
  const completed = tasks?.some(task => task.status === "submitted")
  const all_completed = tasks?.every(task => task.status === "submitted")
  console.log("completed", completed)
  console.log("check", check)
  console.log("estimated_date_null", estimated_date_null)
  console.log("status_null", status_null)
  console.log("work_start_null", work_start_null)

  const approve = async task_id => {
    const data = {
      status: "approved",
      vendor_id: rfqDetail.assigned_vendor_id,
      rfq_id: id,
    }
    try {
      const response = await verifyRfqTaskDocs(task_id, data)
      if (response.status === true) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Task approved successfully!",
        })
        fetchRfqPayementMilestones()
        fetchRfqDetail()
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response?.message || "An error occurred while approving task.",
        })
      }
    } catch (error) {
      console.error("Error approving task:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "An unexpected error occurred.",
      })
    }
  }
  console.log("rfq rejected by vendor", vendorsRejected)

  var columnNames = [
    "Brand Name",
    "Work Detail",
    "Payment Term",
    "Proposal Amount (GST EXTRA)",
    "GST Amount",
    "Total Proposal Amount",
    "Work Timeline",
    "Work Warranty (In Days)",
    "Final Amount",
    "Negotiation Cost",
  ]

  if (
    rfqDetail.assigned_vendor_id === null &&
    displayedVendors.some(
      vendor =>
        vendor.is_negotiated_by_vendor === null ||
        vendor.is_negotiated_by_vendor === 1
    )
  ) {
    columnNames = [
      "Brand Name",
      "Work Detail",
      "Payment Term",
      "Proposal Amount (GST EXTRA)",
      "GST Amount",
      "Total Proposal Amount",
      "Work Timeline",
      "Work Warranty (In Days)",
      "Final Amount",
      "Negotiation Cost",
      "Actions",
    ]
  }
  console.log(
    "is Action Column Visible",
    rfqDetail.assigned_vendor_id,
    displayedVendors.some(
      vendor =>
        vendor.is_negotiated_by_vendor === null ||
        vendor.is_negotiated_by_vendor === 1
    )
  )
  const [taskList, setTaskList] = useState([""])

  const approveMilestone = async ms_id => {
    const data = {
      vendor_id: rfqDetail.assigned_vendor_id,
      rfq_id: id,
      milestone_status: "Approved",
      milestone_id: ms_id,
    }
    try {
      const response = await milestoneStatusByAdmin(data)
      const loadingSwal = Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading()
        },
      })
      if (response.status === true) {
        loadingSwal.close()
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Milestone was approved successfully",
        })
      } else {
        loadingSwal.close()
        Swal.fire({
          icon: "error",
          title: "Failed",
          text:
            response?.message || "An error occurred while approving milestone.",
        })
      }
    } catch (error) {
      console.error("Error  occurred while approving milestone:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.msg || "An unexpected error occurred.",
      })
    }
    fetchRfqPayementMilestones()
  }

  const rejectMilestone = async ms_id => {
    const data = {
      vendor_id: rfqDetail.assigned_vendor_id,
      rfq_id: id,
      milestone_status: "Rework",
      milestone_id: ms_id,
    }
    try {
      const response = await milestoneStatusByAdmin(data)
      const loadingSwal = Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading()
        },
      })
      if (response.status === true) {
        loadingSwal.close()
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Milestone was sent to vendor for rework successfully",
        })
      } else {
        loadingSwal.close()
        Swal.fire({
          icon: "error",
          title: "Failed",
          text:
            response?.message ||
            "An error occurred while sending milestone to vendor for rework.",
        })
      }
    } catch (error) {
      console.error(
        "Error  occurred while sending milestone to vendor for rework:",
        error
      )
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.msg || "An unexpected error occurred.",
      })
    }
    fetchRfqPayementMilestones()
  }
  const taskOptions =
    rfqDetail?.tasks?.map(task => ({
      value: task.id, // Using task ID as value
      label: task.task, // Using task name as label
    })) || []

  const addPayment = async (mid, amt) => {
    const data = {
      paid_amount: amt,
      milestone_amount: amt,
      rfq_id: id,
      vendor_id: rfqDetail.assigned_vendor_id,
      milestone_id: mid,
    }
    const loadingSwal = Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      showConfirmButton: false,
      onBeforeOpen: () => Swal.showLoading(),
    })
    try {
      const response = await rfqMilestonePayment(data)
      if (response?.status === true) {
        fetchRfqQuotesDetail()
        fetchRfqDetail()
        fetchRfqPayementMilestones()
        await Swal.fire({
          title: "Success",
          icon: "success",
          text: "Paid successfully",
        })
      } else {
        loadingSwal.close()
        Swal.fire({
          icon: "error",
          title: "Failed",
          text:
            response?.message || "An error occurred while rejecting milestone.",
        })
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        icon: "error",
        text: error || "Some error occured",
      })
    } finally {
      loadingSwal.close()
      setModalType(null)
    }
  }
  console.log("rfq taskOptions", taskOptions, rfqDetail?.tasks)
  console.log(
    "milestone",
    taskOptions.filter(item => !taskList.includes(item.value))
  )
  const getPaymentTotals = milestones => {
    if (!milestones) return { total: 0, remaining: 0 }

    const total = milestones.reduce(
      (sum, milestone) => sum + (parseFloat(milestone.payment_amount) || 0),
      0
    )

    const requiredTotal = parseFloat(rfqDetail.total_final_amount) || 0
    const remaining = requiredTotal - total

    return {
      total: total.toFixed(2),
      remaining: remaining.toFixed(2),
      requiredTotal: requiredTotal.toFixed(2),
    }
  }
  const milestoneValidationSchema = useMemo(() => {
    return Yup.object({
      milestones: Yup.array()
        .of(
          Yup.object().shape({
            title: Yup.string().required("Title is required"),
            payment_amount: Yup.number()
              .typeError("Must be a number")
              .required("Payment Amount is required")
              .positive("Must be positive"),
            advance_payment: Yup.number()
              .typeError("Must be a number")
              .nullable()
              .test(
                'conditional-validation', 
                'Invalid advance payment',
                function(value) {
                  if (value === null || value === undefined || value === "") {
                    return true;
                  }
                  if (value < 0) {
                    return this.createError({
                      message: 'Must not be negative',
                      path: this.path
                    });
                  }
                  if (value > this.parent.milestone_amount) {
                    return this.createError({
                      message: 'Advance Payment must be less than amount',
                      path: this.path
                    });
                  }
                  return true;
                }
              ),
            task_ids: Yup.array()
              .min(1, "At least one task must be selected")
              .required("Tasks are required"),
          })
        )
        .test(
          "all-tasks-assigned",
          "All tasks must be assigned to milestones",
          function (milestones) {
            if (!taskOptions || taskOptions.length === 0) return true

            const allTaskIds = taskOptions.map(option => option.value)
            const assignedTaskIds = milestones.flatMap(m => m.task_ids)

            const unassignedTasks = allTaskIds.filter(
              id => !assignedTaskIds.includes(id)
            )

            return unassignedTasks.length === 0
          }
        )
        .test(
          "total-payment-amount",
          "Total payment amount must match the RFQ remaining amount",
          function (milestones) {
            const totals = getPaymentTotals(milestones)
            return parseFloat(totals.remaining) === 0
          }
        ),
    })
  }, [taskOptions, rfqDetail.new_final_remaining_amount])

  const milestoneValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      milestones: [
        {
          rfq_id: id, // Assuming id is available from props/context
          title: "",
          payment_amount: "",
          task_ids: [],
          vendor_id: rfqDetail.assigned_vendor_id,
          advance_payment: ""
        },
      ],
    },
    validationSchema: milestoneValidationSchema,

    onSubmit: async (values, { resetForm }) => {
      const allTaskIds = taskOptions.map(o => o.value)
      const assignedIds = values.milestones.flatMap(m => m.task_ids)
      const unassignedTasks = allTaskIds.filter(id => !assignedIds.includes(id))
      console.log(
        "Unassigned Tasks",
        unassignedTasks,
        "All Task IDs",
        allTaskIds,
        "Assigned IDs",
        assignedIds
      )
      if (unassignedTasks.length > 0) {
        // Get task names for better error message
        const unassignedTaskNames = unassignedTasks
          .map(id => {
            const task = taskOptions.find(t => t.value === id)
            return task ? task.label : `Task ${id}`
          })
          .join(", ")

        Swal.fire({
          title: "Error",
          icon: "error",
          html: `The following tasks are not assigned to any milestone: 
                 <strong>${unassignedTaskNames}</strong>`,
        })
        return
      }

      const totals = getPaymentTotals(values.milestones)

      if (parseFloat(totals.remaining) !== 0) {
        Swal.fire({
          title: "Error",
          icon: "error",
          html: `Total payment amount must equal the RFQ remaining amount.<br>
               Current total: <strong>${totals.total}</strong><br>
               Required total: <strong>${totals.requiredTotal}</strong>`,
        })
        return
      }

      const loadingSwal = Swal.fire({
        title: "Saving Milestones...",
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => Swal.showLoading(),
      })

      try {
        const response = await updateMilestones(values)
        if (response?.status === true) {
          fetchRfqPayementMilestones()
          fetchRfqQuotesDetail()
          fetchRfqDetail()
          await Swal.fire({
            title: "Success",
            icon: "success",
            text: "Milestones saved successfully",
          })
          resetForm()
        } else {
          throw new Error("Failed to save milestones")
        }
      } catch (error) {
        Swal.fire({
          title: "Error",
          icon: "error",
          text: error?.response?.data?.message || "Failed to save milestones",
        })
      } finally {
        loadingSwal.close()
        setModalType(null)
      }
    },
  })

  const addNewMilestoneValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      rfq_id: Number(id), // Assuming id is available from props/context
      milestone_title:"",
      milestone_amount: "",
      tasks: [],
      vendor_id: rfqDetail.assigned_vendor_id,
      advance_payment:""
    },
    
    validationSchema: Yup.object().shape({
        milestone_title: Yup.string().required("Title is required"),
        milestone_amount: Yup.number()
          .typeError("Must be a number")
          .required("Payment Amount is required")
          .positive("Must be positive"),
        advance_payment: Yup.number()
          .typeError("Must be a number")
          .nullable()
          .test(
            'conditional-validation', 
            'Invalid advance payment',
            function(value) {
              if (value === null || value === undefined || value === "") {
                return true;
              }
              if (value < 0) {
                return this.createError({
                  message: 'Must not be negative',
                  path: this.path
                });
              }
              if (value > this.parent.milestone_amount) {
                return this.createError({
                  message: 'Advance Payment must be less than amount',
                  path: this.path
                });
              }
              return true;
            }
          )
      }),

    onSubmit: async (values) => {
      try {
        const loadingSwal = Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
        const response = await rfqMilestoneExtraWork(values)
        if (response?.status === true) {
          loadingSwal.close()
          await Swal.fire({
            title: "Success",
            icon: "success",
            text: "Milestone saved successfully",
          })
          fetchRfqPayementMilestones()
          fetchRfqDetail()
          changeModal()
          fetchMilestoneList()
        } else {
          loadingSwal.close()
          Swal.fire({
          icon: "error",
          title: "Failed",
          text:
            response?.message || "An error occurred while rejecting milestone.",
        })
        }
      } catch (error) {
        loadingSwal.close()
        Swal.fire({
          title: "Error",
          icon: "error",
          text: error?.response?.data?.message || "Failed to save milestone",
        })
      } finally {
        loadingSwal.close()
        setTasks1([{ task: "", document_required: "", estimated_completion_date: "" }])
        setModalType(null)
        fetchRfqPayementMilestones()
      }
    },
  })
  const paymentTotals = getPaymentTotals(milestoneValidation.values.milestones)

  console.log("Milestone Validation Values", milestoneValidation)
  const getTaskNames = taskIds => {
    return taskIds
      .map(id => {
        const task = taskOptions.find(t => t.value === id)
        return task ? task.label : `Unknown Task (${id})`
      })
      .join(", ")
  }
  console.log("Milestone Validation", milestoneValidation)

  // Helper functions for adding/removing rows
  const handleAddRowForMilestone = () => {
    milestoneValidation.setFieldValue("milestones", [
      ...milestoneValidation.values.milestones,
      {
        rfq_id: id,
        title: "",
        payment_amount: "",
        task_ids: [],
        vendor_id: rfqDetail.assigned_vendor_id, // Adding vendor_id here
      },
    ])
  }

  const handleDeleteRowForMilestone = index => {
    const updatedMilestones = milestoneValidation.values.milestones.filter(
      (_, i) => i !== index
    )
    milestoneValidation.setFieldValue("milestones", updatedMilestones)
  }
  const getStatusColor = status => {
    switch (status) {
      case "Open":
        return "text-secondary" // Primary color
      case "Ticket Created":
        return "text-primary" // Success color
      case "In Progress":
        return "text-warning" // Warning color
      case "In Progress (reassigned)":
        return "text-warning" // Warning color
      case "Closed":
        return "text-success" // Danger color
      case "Declined(with reason)":
        return "text-danger" // Danger color
      default:
        return ""
    }
  }

  const navigate = useNavigate()
  const actionTaken = tasks?.every(task => task.status !== "submitted") || false

  const changeDateFormat = date => {
    return date.toString().split("-").reverse().join("-")
  }

  const some_status_pending = paymentDetails.some(
    item => item.status === "pending"
  )

  /*const acceptAdvPayment = async (id, invoice_no) => {
    const data = {
      rfq_payment_id: id,
      rfq_invoice_no: invoice_no,
      payment_date: new Date().toISOString().split("T")[0],
      status: "paid",
    }
    const loadingSwal = Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      showConfirmButton: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      },
    })
    try {
      const response = await acceptRejectAdvRfqPayment(data)
      if (response?.status === true) {
        await Swal.fire({
          title: "Success",
          icon: "success",
          text: "Advance Payment Request was accepted",
        })
        fetchAdvanceRfqPayment()
      } else {
        throw new Error("Failed to accept Advance Payment Request")
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        icon: "error",
        text:
          error?.response?.data?.message ||
          "Failed to accept Advance Payment Request",
      })
    } finally {
      loadingSwal.close()
    }
  }*/

  const handleAddRow = () => {
    setTasks1([...tasks1, { task: "", document_required: "", estimated_completion_date:"" }])
  }

  const handleDeleteRow = index => {
    const updatedTasks = tasks1.filter((_, i) => i !== index)
    setTasks1(updatedTasks)
  }

  const handleTaskChange = (index, field, value) => {
    const updatedTasks = [...tasks1]
    updatedTasks[index][field] = value
    setTasks1(updatedTasks)
    addTaskValidation.setFieldValue("tasks", updatedTasks) // Assuming you want to update formik values as well
  }
  const handleTaskForMS = (index, field, value) => {
    const updatedTasks = [...tasks1]
    updatedTasks[index][field] = value
    setTasks1(updatedTasks)
    addNewMilestoneValidation.setFieldValue("tasks", updatedTasks) // Assuming you want to update formik values as well
  }

  const handleMilestoneChange = (event) => {
    const selectedId = event.target.value;
    const selectedMilestone = milestoneOptions.find(ms => ms.id === Number(selectedId))
    if (selectedMilestone) {
      setSelectedMilestoneAmt(selectedMilestone.pending_amount)
      addPaymentValidation.setFieldValue("is_additional_milestone_payment",selectedMilestone.is_additional_milestone)
      addPaymentValidation.setFieldValue("milestone_amount",selectedMilestone.payment_amount)
    } else {
      setSelectedMilestoneAmt('')
    }
    addPaymentValidation.handleChange(event)
  }

  useEffect(() => {
    if (
      paymentMilestones &&
      paymentMilestones.length > 0 &&
      isOpen1.length === 0
    ) {
      const initialOpenIds = paymentMilestones.map(milestone => milestone.id)
      setIsOpen1(initialOpenIds)
    }
  }, [paymentMilestones])

  const toggleVisibility1 = index => {
    setIsOpen1(prevIndex => {
      if (isOpen1?.includes(index)) {
        // If the milestone is already open, close it
        return isOpen1?.filter(i => i !== index)
      } else {
        // Otherwise, open it
        return [...prevIndex, index]
      }
    })
  }

  const today = new Date().toISOString().split("T")[0]
  console.log("New milestone validation values",addNewMilestoneValidation)
  return (
    <div className="page-content">
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg={12}>
            <CardTitle className="h4 mb-3" style={{ fontSize: "20px" }}>
              <div className="d-flex gap-2 ">
                <i
                  className="mdi mdi-arrow-left font-size-20"
                  style={{ color: "grey" }}
                  onClick={() => {
                    navigate(-1)
                  }}
                ></i>
                RFQ Details
              </div>
            </CardTitle>
          </Col>
        </Row>
        <Card>
          <CardBody>
            <div className="d-flex align-items-start">
              <div className="me-2">
                <h5 className="card-title mb-4">RFQ Logs</h5>
              </div>
            </div>
            <SimpleBar className="mt-2" style={{ maxHeight: "280px" }}>
              {rfqLogs &&
                rfqLogs.map((track, index) => (
                  <ul key={index} className="verti-timeline list-unstyled">
                    <li
                      className={`event-list ${
                        track.status_name ? "active" : ""
                      }`}
                      style={{ marginBottom: "20px" }} // Add margin bottom for spacing
                    >
                      <div className="event-timeline-dot">
                        <i
                          className={`bx bxs-right-arrow-circle font-size-18 ${
                            track.status_name && "bx-fade-right"
                          }`}
                        ></i>
                      </div>
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <h5 className="font-size-14">
                            {track.log_message}

                            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                          </h5>
                        </div>
                        <div
                          className={`flex-grow-1 ${getStatusColor(
                            track.status_name
                          )}`}
                        >
                          {track.status_name} ({track.created_at})
                        </div>
                      </div>
                    </li>
                  </ul>
                ))}
            </SimpleBar>
          </CardBody>
        </Card>
        {rfqDetail.current_status_id===13 && (
          <Col lg={12}>
            <Alert color="success" role="alert" className="text-center">
              RFQ Has Been Closed
            </Alert>
          </Col>
        )}
  <Row className="mb-4">
    {/* Vendor Bid Details - lg=4 */}
   

    {/* RFQ Details - lg=8 */}
    <Col lg={8}>
    <Card>
      <CardBody>
        <CardTitle className="fw-bold">RFQ Details</CardTitle>
        <div className="table-responsive">
              <table className="table">
               
          <tbody>
            <tr>
              <th style={{ whiteSpace: "nowrap" }}>Project</th>
              <td>{rfqDetail.project_name}</td>
              <th style={{ whiteSpace: "nowrap" }}>RFQ Code</th>
              <td>{rfqDetail.rfq_code}</td>
            </tr>
            {rfqDetail.ticket_id && (
              <tr>
                <th style={{ whiteSpace: "nowrap" }}>Ticket ID</th>
                <td colSpan="3">
                  <Link
                    to={`/tickets/view-ticket/${rfqDetail.ticket_id}`}
                    className="text-primary"
                  >
                    {rfqDetail.ticket_no}
                  </Link>
                </td>
              </tr>
            )}
            <tr>
              <th style={{ whiteSpace: "nowrap" }}>RFQ Title</th>
              <td>{rfqDetail.rfq_title}</td>
              <th style={{ whiteSpace: "nowrap" }}>Goods/Services Head</th>
              <td>{rfqDetail.head_text}</td>
            </tr>
            <tr>
              <th style={{ whiteSpace: "nowrap" }}>Goods/Services Sub-Head</th>
              <td>{rfqDetail.subhead_text}</td>
              <th style={{ whiteSpace: "nowrap" }}>Budget (Rs)</th>
              <td>
                {rfqDetail.budget
                  ? formatNumberWithCommas(rfqDetail.budget)
                  : "--"}
              </td>
            </tr>
            <tr>
              <th style={{ whiteSpace: "nowrap" }}>Issue Date</th>
              <td>
                {rfqDetail.issue_date
                  ? changeDateFormat(rfqDetail.issue_date)
                  : "--"}
              </td>
              <th style={{ whiteSpace: "nowrap" }}>Valid Upto</th>
              <td>{rfqDetail.valid_to}</td>
            </tr>
            <tr>
              <th style={{ whiteSpace: "nowrap" }}>Total Final Amount</th>
              <td>
                {rfqDetail.total_final_amount
                  ? formatNumberWithCommas(rfqDetail.total_final_amount)
                  : "--"}
              </td>
              <th style={{ whiteSpace: "nowrap" }}>Remaining Amount</th>
              <td>
                {rfqDetail.new_final_remaining_amount
                  ? formatNumberWithCommas(rfqDetail.new_final_remaining_amount)
                  : "--"}
              </td>
            </tr>
            <tr>
              <th style={{ whiteSpace: "nowrap" }}>Additional Milestone Amount</th>
              <td>
                {rfqDetail.additional_milestone_work_payment
                  ? formatNumberWithCommas(rfqDetail.additional_milestone_work_payment)
                  : "--"}
              </td>
              <th style={{ whiteSpace: "nowrap" }}>Total Paid Amount</th>
              <td>
                {rfqDetail.total_paid_amount
                  ? formatNumberWithCommas(rfqDetail.total_paid_amount)
                  : "--"}
              </td>
            </tr>
            {vendorBidDetails.vendor_name && (
              <tr>
                <th style={{ whiteSpace: "nowrap" }}>Assigned To</th>
                <td>{vendorBidDetails.vendor_name}</td>
                <th style={{ whiteSpace: "nowrap" }}>Current Status</th>
                <td>
                  <span
                    className={`badge rounded-pill font-size-11 ${getStatusBadgeClassOfMainRFQ(
                      rfqDetail.current_status_id
                    )}`}
                  >
                    {rfqDetail.current_status_name}
                  </span>
                </td>
              </tr>
            )}
            <tr>
              <th style={{ whiteSpace: "nowrap" }}>Tender Document</th>
              <td>
                <a
                  className="d-inline-flex focus-ring py-1 px-2 text-decoration-none border rounded-2"
                  target="_blank"
                  rel="noreferrer"
                  href={rfqDetail.tender_document_viewPath}
                >
                  View
                </a>
              </td>
              <th style={{ whiteSpace: "nowrap" }}>Security Deposit (% of total final amount)</th>
              <td>
                {rfqDetail.security_deposit_amount
                  ? formatNumberWithCommas(rfqDetail.security_deposit_amount) + "%"
                  : "--"}
              </td>
            </tr>
            <tr>
              <th style={{ whiteSpace: "nowrap" }}>Requirement Spec.</th>
              <td>{rfqDetail.requirement_specification}</td>
              <th style={{ whiteSpace: "nowrap" }}>Work TimeLine</th>
              <td>{rfqDetail.work_timeline
                  ? changeDateFormat(rfqDetail.work_timeline)
                  : "--"}</td>
            </tr>
            <tr>
              {rfqDetail.invoice_doc_viewPath && (
                <>
                  <th style={{ whiteSpace: "nowrap" }}>Invoice Document</th>
                  <td>
                    <a
                      className="d-inline-flex focus-ring py-1 px-2 text-decoration-none border rounded-2"
                      target="_blank"
                      rel="noreferrer"
                      href={rfqDetail.invoice_doc_viewPath}
                    >
                      View
                    </a>
                  </td>
                </>
              )}
            </tr>
          </tbody>
        </table>
        </div>
      </CardBody>
    </Card>
  </Col>
   <Col lg={4}>
      <Card>
        <CardBody>
          <CardTitle className="fw-bold">Vendor Bid Details</CardTitle>
            <div className="table-responsive">
              <table className="table">
            <tbody>
              <tr>
                <th style={{ whiteSpace: "nowrap" }}>Brand Name</th>
                <td>{vendorBidDetails.brand_name}</td>
              </tr>
              <tr>
                <th style={{ whiteSpace: "nowrap" }}>Proposal Amount (GST EXTRA)</th>
                <td>
                  {vendorBidDetails.proposal_amount
                    ? formatNumberWithCommas(vendorBidDetails.proposal_amount)
                    : "--"}
                </td>
              </tr>
              <tr>
                <th style={{ whiteSpace: "nowrap" }}>GST Amount</th>
                <td>
                  {vendorBidDetails.gst_amount
                    ? formatNumberWithCommas(vendorBidDetails.gst_amount)
                    : "--"}
                </td>
              </tr>
              <tr>
                <th style={{ whiteSpace: "nowrap" }}>Total Proposal Amount</th>
                <td>
                  {vendorBidDetails.total_invoice_amount
                    ? formatNumberWithCommas(vendorBidDetails.total_invoice_amount)
                    : "--"}
                </td>
              </tr>
              <tr>
                <th style={{ whiteSpace: "nowrap" }}>Work Timeline</th>
                <td>
                  {vendorBidDetails.work_timeline
                    ? changeDateFormat(vendorBidDetails.work_timeline)
                    : "--"}
                </td>
              </tr>
              <tr>
                <th style={{ whiteSpace: "nowrap" }}>Payment Terms</th>
                <td>{vendorBidDetails.payment_term}</td>
              </tr>
              <tr>
                <th style={{ whiteSpace: "nowrap" }}>Brand / Work Details</th>
                <td>{vendorBidDetails.work_detail}</td>
              </tr>
              <tr>
                <th style={{ whiteSpace: "nowrap" }}>
                  Work Warranty (from RFQ Closing)
                </th>
                <td>{vendorBidDetails.work_warranty}</td>
              </tr>
              {vendorBidDetails.negotiation_cost !== null && (
                <tr>
                  <th style={{ whiteSpace: "nowrap" }}>Negotiation Cost</th>
                  <td>
                    {vendorBidDetails.negotiation_cost
                      ? formatNumberWithCommas(vendorBidDetails.negotiation_cost)
                      : "--"}
                  </td>
                </tr>
              )}
            </tbody>
            
          </table>
          </div>
        </CardBody>
      </Card>
    </Col>
  </Row>
    <Card>
      <CardBody>
        <CardTitle>Task Details</CardTitle>
        <div className="table-responsive">
          <Table className="table table-striped mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Task Name</th>
                <th>Task Timeline</th>
                <th>Milestone</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {(rfqDetail.tasks || []).map(
                (row, index) => (
                  <tr key={index}>
                    <th scope="row">{index + 1}</th>
                    <td>{row.task}</td>
                    <td>{row.estimated_completion_date?changeDateFormat(row.estimated_completion_date):"--"}</td>
                    <td>{row.milestones[0]?.title?row.milestones[0]?.title:"--"}</td>
                    <td>
                      <span className={`badge rounded-pill font-size-11 ${getStatusBadgeClassOfRFQMilestone(row.status)}`}>{row.status?row.status:"Not Started"}</span>
                    </td>                        
                  </tr>
                )
              )}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>

        {rfqDetail.current_status_id === 11 && (
          <Alert>
            Vendor justication Reason : {rfqDetail.reject_justification}
            <br></br>
            <br></br>
            Vendor justication File :
            <a
              target="_blank"
              rel="noreferrer"
              href={rfqDetail.reject_justification_file_viewPath}
            >
              <button
                className="btn btn-primary "
                style={{
                  fontSize: "10px",
                  padding: "2px 5px",
                  marginLeft: "2px",
                }}
              >
                View
              </button>
            </a>
          </Alert>
        )}

        {paymentMilestones && paymentMilestones.length > 0 && (
          <Card>
            <CardBody>
              <CardTitle className="h4 mb-3" style={{ fontSize: "20px" }}>
                <Row><Col md={6}>Milestone details</Col>
                {rfqDetail.current_status_id !== 13 &&
                    permission.some(
                      item =>
                        item.page === "add-milestone" &&
                        item.access === 1
                    ) && (
                      <Col md={6}>
                        <Button
                          size="sm"
                          color="primary"
                          style={{ marginRight: "5px" }}
                          className="float-end"
                          onClick={() => {
                            changeModal("addNewMilestones");
                          }}
                        >
                          <i className="mdi mdi-plus me-1" />
                          Add Milestone
                        </Button>
                      </Col>
                  )}
                </Row>
              </CardTitle>
              {paymentMilestones?.map(paymentmilestone => (
                <div
                  key={paymentmilestone.id}
                  className="mb-4 p-3"
                  style={{
                    backgroundColor: "#f8f9fa", // Light gray background
                    borderRadius: "8px",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5>{paymentmilestone.title}</h5>
                    <span
                      className="toggle-icon font-size-24"
                      onClick={() => toggleVisibility1(paymentmilestone.id)}
                      style={{ cursor: "pointer" }}
                    >
                      {isOpen1.includes(paymentmilestone.id) ? "-" : "+"}
                    </span>
                  </div>
                      <Row className="mb-3">
                      <Col md={3}>
                        <p>
                          <strong>Milestone Budget Amount:</strong>{" "}
                          {paymentmilestone.payment_amount
                            ? formatNumberWithCommas(
                                paymentmilestone.payment_amount
                              )
                            : "--"}
                        </p>
                      </Col>
                      <Col md={3}>
                        <p>
                          <strong>Milestone Status:</strong>{" "}
                          <span
                            className={`badge rounded-pill font-size-11 ${getStatusBadgeClassOfRFQMilestone(
                              paymentmilestone.milestone_status
                            )}`}
                          >
                            {paymentmilestone.milestone_status}
                          </span>
                        </p>
                      </Col>
                      <Col md={3}>
                        <p>
                          <strong>Payment Status:</strong>{" "}
                          <span
                            className={`badge rounded-pill font-size-11 ${getStatusBadgeClassOfRFQMilestone(
                              paymentmilestone.milestone_payment_status
                            )}`}
                          >
                            {paymentmilestone.milestone_payment_status}
                          </span>
                        </p>
                      </Col>
                      <Col md={3} className="text-end">
                        <div className="d-flex">
                          {paymentmilestone?.milestone_status === "Pending" &&
                            permission.some(
                              item =>
                                item.page === "add-task" &&
                                item.access === 1
                            ) && (
                              <Button
                                size="sm"
                                color="primary"
                                style={{ marginRight: "5px" }}
                                onClick={() => {
                                  setMilestoneId(paymentmilestone.id);
                                  changeModal("AddTaskModal");
                                }}
                              >
                                <i className="mdi mdi-plus me-1" />
                                Add Task
                              </Button>
                          )}
                        {paymentmilestone?.milestone_status === "Sent For Review" && (
                            <>
                              {paymentmilestone.tasks.every(task => task.status === "approved") &&
                                permission.some(
                                  item =>
                                    item.page === "total-milestone-approve" && 
                                    item.access === 1
                                ) && (
                                  <Button
                                    size="sm"
                                    color="success"
                                    style={{ marginRight: "5px" }}
                                    onClick={() => approveMilestone(paymentmilestone.id)}
                                  >
                                    Approve
                                  </Button>
                                )}

                              {paymentmilestone?.tasks.some(task => task.status === "rejected") &&
                                permission.some(
                                  item =>
                                    item.page === "total-milestone-approve" && 
                                    item.access === 1
                                ) && (
                                  <Button
                                    size="sm"
                                    color="danger"
                                    onClick={async () => {
                                      const result = await Swal.fire({
                                        title: "Are you sure?",
                                        text: "All the unactioned tasks will be automatically rejected.",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonText: "Rework",
                                        cancelButtonText: "Cancel",
                                        reverseButtons: true,
                                      });

                                      if (result.isConfirmed) {
                                        rejectMilestone(paymentmilestone.id);
                                      }
                                    }}
                                  >
                                    Rework
                                  </Button>
                                )}
                            </>
                          )}
                        {paymentmilestone?.invoice &&
                          permission.some(
                            item =>
                              item.page === "view-invoice-details" &&
                              item.access === 1
                          ) && (
                            <Button
                              size="sm"
                              color="primary"
                              onClick={() => {
                                setInvoice(paymentmilestone.invoice);
                                changeModal("viewInvoiceDoc");
                              }}
                            >
                              View Invoice Details
                            </Button>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <div
                    className={`hidden-content ${
                      isOpen1.includes(paymentmilestone.id)
                        ? "visible"
                        : "hidden"
                    }`}
                    style={{
                      transition: "max-height 0.3s ease-in-out",
                      maxHeight: isOpen1.includes(paymentmilestone.id)
                        ? "10000px"
                        : "0",
                      overflow: "hidden",
                    }}
                  >
                  
      <div className="row">
          {paymentmilestone.tasks?.map(task =>(
            <div className="col-md-6 col-xl-4 mb-4" key={task.id}>
              <Card className="h-100">
                <CardHeader className="bg-light d-flex justify-content-between align-items-center">
          <h5 className="mb-0">{task.task}</h5>
          {(rfqDetail.current_status_id === 10 ||
            rfqDetail.current_status_id === 9 ||
            rfqDetail.current_status_id === 12) &&
            task.status === "submitted" &&
            paymentmilestone.milestone_status === "Sent For Review" && (
              <div className="d-flex gap-2 ms-auto">
                {permission.some(
                  item =>
                    item.page === "task-approve-reject-under-milestone" && 
                    item.access === 1
                ) && (
                  <Button
                    size="sm"
                    color="success"
                    onClick={() => approve(task.id)}
                    style={{ width: "80px" }}
                  >
                    Approve
                  </Button>
                )}

                {permission.some(
                  item =>
                    item.page === "task-approve-reject-under-milestone" && 
                    item.access === 1
                ) && (
                  <Button
                    size="sm"
                    color="danger"
                    onClick={() => {
                      setTaskId(task.id);
                      changeModal("rework");
                    }}
                    style={{ width: "80px" }}
                  >
                    Reject
                  </Button>
                )}
              </div>
          )}
        </CardHeader>
        <CardBody>
          <div className="table-responsive">
            <table className="table table-borderless mb-0">
              <tbody>
                {/* Documents Required */}
                <tr>
                  <th style={{ whiteSpace: "nowrap" }}>Documents Required</th>
                  <td>{task.document_required}</td>
                </tr>
                
                {/* Estimated Completion Date */}
                <tr>
                  <th style={{ whiteSpace: "nowrap" }}>Estimated Completion Date</th>
                  <td>
                    {task.estimated_completion_date
                      ? changeDateFormat(task.estimated_completion_date)
                      : "--"}
                  </td>
                </tr>
                
                {/* Task Status */}
                <tr>
                  <th style={{ whiteSpace: "nowrap" }}>Task Status</th>
                  <td>
                    <span className={`badge rounded-pill font-size-11 ${getStatusBadgeClassOfRFQMilestone(task.status)}`}>
                      {task.status || "Not Started"}
                    </span>
                  </td>
                </tr>
                
                {/* Start Date */}
                <tr>
                  <th style={{ whiteSpace: "nowrap" }}>Start Date</th>
                  <td>
                    {task.work_start ? changeDateFormat(task.work_start) : "--"}
                  </td>
                </tr>
                {/* Work Progress */}
              <tr>
                <th style={{ whiteSpace: "nowrap" }}>Work Progress (%)</th>
                <td>
                  <span className="me-2">
                    {task?.work_progress?.length > 0
                      ? task.work_progress[0]?.work_progress || "--"
                      : "--"}
                  </span>
                  <a
                    className="d-inline-flex align-items-center text-decoration-none"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if(task.work_progress?.length > 0){
                        setDocuments(task.work_progress)
                        setPics(task.support_doc)
                      }
                      else{
                        setDocuments([
                            {
                              created_at: null,
                              view_path: null,
                              work_progress: null,
                              work_description: null,
                            },
                        ])
                        setPics([{view_path: null}])
                      }
                      changeModal("workProgressTable");
                    }}
                  >
                    <i className="mdi mdi-arrow-right-circle-outline " />
                  </a>
                </td>
              </tr>

                
                {/* Rework Description */}
               {task.rework_reason && (
                <tr>
                  <th style={{ whiteSpace: "nowrap" }}>Rework Description</th>
                  <td>{task.rework_reason || "--"}</td>
                </tr>)}
                
                {/* Rework Justification */}
                               {task.rework_reject_justification && (

                <tr>
                  <th style={{ whiteSpace: "nowrap" }}>Rework Justification</th>
                  <td>{task.rework_reject_justification || "--"}</td>
                </tr>)}
               {/* Submission Proof */}


{/* Supporting Docs */}
<tr>
  <th style={{ whiteSpace: "nowrap" }}>Supporting Doc</th>
  <td>
    {/* <a
      className="d-inline-flex focus-ring py-1 px-2 text-decoration-none border rounded-2 mb-2"
      onClick={() => {
        task.support_doc?.length > 0
          ? setDocuments(task.support_doc)
          : setDocuments([{
              created_at: null,
              view_path: null,
              work_progress: null,
              work_description: null,
            }]);
        changeModal("supportDocsTable");
      }}
    >
      View Details
    </a> */}
    
    {/* Fixed height container with horizontal scroll */}
    <div style={{height: task.support_doc?.length > 0 ? "100px" : "20px", overflowY: "hidden" }}>
      <div style={{ 
        display: "flex", 
        overflowX: "auto",
        paddingBottom: "10px",
        height: "100%",
        alignItems: "flex-start"
      }}>
{task.support_doc && task.support_doc.length > 0 && task.work_progress && task.work_progress.length > 0 && (
  task.support_doc.filter(doc => doc.work_progress_id === task.work_progress[0].id).map((sdoc, index) => (          <div
              key={index}
              style={{
                flexShrink: 0,
                   width: "50px",
                height: "50px",
                marginRight: "10px",
                overflow: "hidden",
                borderRadius: "15px",
              }}
            >
              <a
                href={sdoc.view_path}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={sdoc.view_path}
                  alt={`Supporting Doc ${index}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </a>
            </div>
        )))}
      </div>
    </div>
  </td>
</tr>
<tr>
  <th style={{ whiteSpace: "nowrap" }}>Submission Proof</th>
  <td>
    {/* <a
      className="d-inline-flex focus-ring py-1 px-2 text-decoration-none border rounded-2 mb-2"
      onClick={() => {
        task.files?.length > 0
          ? setDocuments(task.files)
          : setDocuments([{
              created_at: null,
              view_path: null,
              work_progress: null,
              work_description: null,
            }]);
        changeModal("submissionProofTable");
      }}
    >
      View Details
    </a> */}
    
    {/* Fixed height container with horizontal scroll */}
    <div style={{ height: task.files?.length > 0 ? "100px" : "20px", overflowY: "hidden" }}>
      <div style={{ 
        display: "flex", 
        overflowX: "auto",
        paddingBottom: "10px",
        height: "100%",
        alignItems: "flex-start"
      }}>
        {task.files?.map((file, index) => (
          file.view_path && (
            <div
              key={index}
              style={{
                flexShrink: 0,
                 width: "50px",
                height: "50px",
                marginRight: "10px",
                overflow: "hidden",
                borderRadius: "15px",
              }}
            >
              <a
                href={file.view_path}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={file.view_path}
                  alt={`Submission ${index}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </a>
            </div>
          )
        ))}
      </div>
    </div>
  </td>
</tr>
                
                                </tbody>
                              </table>
                            </div>
                          </CardBody>
                        </Card>
                      </div>
                    ))}
                  </div>
                  </div>
                </div>
              ))}
            </CardBody>
          </Card>
        )}
        {paymentMilestones && paymentMilestones.length > 0 && (
          <Card>
    <CardBody>
      <CardTitle className="fw-bold">
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <span>Payment History</span>
    {rfqDetail.current_status_id !== 13 &&
      permission.some(
        item =>
          item.page === "add-payments" &&
          item.access === 1
      ) && (
        <Button
          size="sm"
          color="primary"
          onClick={() => {
            changeModal("addPayment");
          }}
        >
          <i className="mdi mdi-plus me-1" />
          Add Payment
        </Button>
    )}
  </div>
</CardTitle>

      <div className="table-responsive">
        <Table className="table table-striped mb-0">
          <thead>
            <tr>
              <th>#</th>
              <th>Milestone Title</th>
              <th>Milestone / Requested Amount</th>
              <th>Requested on</th>
              <th>Description</th>
              <th>Status</th>
              <th>Payment Approval Status</th>
              <th>Paid Amount</th>
              <th>Payment Date</th>
              <th>Rejection Reason</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paymentDetails?.map((item, index) => (
              <tr key={item.id}>
                <th scope="row">{index + 1}</th>
                <td>{item.milestone_title || "--"}</td>
                <td>
                  {item.amount_requested
                    ? formatNumberWithCommas(item.amount_requested)
                    : "--"}
                </td>
                <td>
                  {item.requested_date
                    ? changeDateFormat(item.requested_date)
                    : "--"}
                </td>
                <td>{item.request_advance_desc?item.request_advance_desc:"--"}</td>
                <td>{item.status?item.status:"--"}</td>
                <td>
                  {item.is_approved == 1 ? "Approved" : item.is_approved == 0 ? "Not Approved" : "--"}
                </td>
                <td>
                  {item.paid_amount
                    ? formatNumberWithCommas(item.paid_amount)
                    : "--"}
                </td>
                <td>
                  {item.payment_date
                    ? changeDateFormat(item.payment_date)
                    : "--"}
                </td>
                <td>{item.reject_advance_desc || "--"}</td>
                <td>
                  {item.status === "pending" && (
                    <>
                      {permission.some(
                        p =>
                          p.page === "payment-request-accept-reject" &&
                          p.access === 1
                      ) && (
                        <>
                          {item.is_approved !== 1 ? (
                            permission.some(p => p.page === "approve-payment-request" && p.access === 1) && (
                              <>
                                <Button
                                  color="warning"
                                  size="sm"
                                  onClick={() => handleApprovePaymentRequest(item)}
                                >
                                  Approve
                                </Button>
                                <Button
                                  color="danger"
                                  size="sm"
                                  style={{ marginLeft: "5px" }}
                                  onClick={() => {
                                    setItem(item)
                                    changeModal("reject_advance_payment_request")
                                  }}
                                >
                                  Reject
                                </Button>
                              </>
                            )
                          ) : (
                            <Button
                              color="success"
                              size="sm"
                              onClick={() => {
                                setItem(item)
                                changeModal("accept_payment_request")
                              }}
                            >
                              Pay
                            </Button>
                          )}
                        </>
                      )}
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </CardBody>
  </Card>
      
        )}
    
      {rfqDetail.current_status_id !== 2 && (

  <Card >
    <CardBody>
      <CardTitle className="fw-bold">Vendor Comparison View</CardTitle>

      {/* Column view container */}
      <div className="d-flex  gap-3">
        {displayedVendors.map((vendor, vendorIndex) =>
         vendor.brand_name ? (
            <Col key={vendor.id} lg={4}>
            <Card>
              <CardHeader><Row>
                <Col>
                  <h5 className="mb-0">{vendor.vendor_name}</h5>
                </Col>
                <Col className="text-end">
                <span className={`badge rounded-pill font-size-11 ${getStatusBadgeClassOfRFQMilestone(vendor.is_rfq_vendor_bid_accepted===1?"Assigned":"Not Assigned")}`}>{vendor.is_rfq_vendor_bid_accepted===1?"Assigned":"Not Assigned"}</span>
                </Col>
                </Row>
              </CardHeader>
              <CardBody >
                <div className="table-responsive" style={{backgroundColor: "#f8f9fa"}}>
                  <table className="table table-borderless mb-0">
                    <tbody >
                      <tr>
                        <th style={{ whiteSpace: "nowrap" }}>Brand Name</th>
                        <td>{vendor.brand_name}</td>
                      </tr>
                      <tr>
                        <th style={{ whiteSpace: "nowrap" }}>Work Details</th>
                        <td>{vendor.work_detail}</td>
                      </tr>
                      <tr>
                        <th style={{ whiteSpace: "nowrap" }}>Payment Terms</th>
                        <td>{vendor.payment_term}</td>
                      </tr>
                      <tr>
                        <th style={{ whiteSpace: "nowrap" }}>Proposal Amount</th>
                        <td>{formatNumberWithCommas(vendor.proposal_amount)}</td>
                      </tr>
                      <tr>
                        <th style={{ whiteSpace: "nowrap" }}>GST Amount</th>
                        <td>{formatNumberWithCommas(vendor.gst_amount)}</td>
                      </tr>
                      <tr>
                        <th style={{ whiteSpace: "nowrap" }}>Total Amount</th>
                        <td>{formatNumberWithCommas(vendor.total_invoice_amount)}</td>
                      </tr>
                      <tr>
                        <th style={{ whiteSpace: "nowrap" }}>Work Timeline</th>
                        <td>{vendor.work_timeline ? changeDateFormat(vendor.work_timeline) : "--"}</td>
                      </tr>
                      <tr>
                        <th style={{ whiteSpace: "nowrap" }}>Warranty</th>
                        <td>{vendor.work_warranty || "--"}</td>
                      </tr>
                      <tr>
                        <th style={{ whiteSpace: "nowrap" }}>Negotiation Cost</th>
                        <td>{vendor.negotiation_cost || "--"}</td>
                      </tr>
                      {rfqDetail.assigned_vendor_id === null && (
                        <tr>
                          <th style={{ whiteSpace: "nowrap" }}>Action</th>
                          <td>
                            {(vendor.is_negotiated_by_vendor === null ||
                              vendor.is_negotiated_by_vendor === 1) && (
                              <>
                                {permission.some(
                                  item =>
                                    item.page === "assign-to-vendor" && 
                                    item.access === 1
                                ) && (
                                  <Button
                                    color="success"
                                    size="sm"
                                    className="me-2"
                                    onClick={() =>
                                      acceptNegotiation(
                                        vendor.id,
                                        vendor.negotiation_cost,
                                        vendor.total_invoice_amount,
                                        vendor.vendor_id
                                      )
                                    }
                                  >
                                    Accept
                                  </Button>
                                )}

                                {permission.some(
                                  item =>
                                    item.page === "negotiation-to-vendor" && 
                                    item.access === 1
                                ) && (
                                  <Button
                                    color="warning"
                                    size="sm"
                                    onClick={() => toggleModal(vendor)}
                                  >
                                    Negotiate
                                  </Button>
                                )}
                              </>
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
            </Col>
             ) : null
        )}
      </div>
    </CardBody>
  </Card>
)}


        {rfqDetail.current_status_id === 14 &&
          permission.some(
            item =>
              item.page === "milestone-first-settings" &&
              item.access === 1
          ) && (
            <Button
              color="primary"
              className="btn-sm m-2"
              onClick={() => changeModal("milestones")}
            >
              Milestones
            </Button>
          )}
        {((rfqDetail.current_status_id === 9 || 
          rfqDetail.current_status_id === 10 || 
          rfqDetail.current_status_id === 12) && allMilestonePaid && allMilestoneApproved) &&
          permission.some(
            item =>
              item.page === "rfq-closed" && 
              item.access === 1
          ) && (
            <>
              <Button
                color="primary"
                onClick={async () => {
                  const result = await Swal.fire({
                    title: "Are you sure you want to close this RFQ?",
                    text: "",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Close",
                    cancelButtonText: "Cancel",
                    reverseButtons: true,
                  });

                  if (result.isConfirmed) {
                    closeValidation.handleSubmit();
                  }
                }}
              >
                Close
              </Button>
            </>
        )}
      </Container>

      <Modal isOpen={modal} toggle={() => setModal(!modal)}>
        <Form onSubmit={negotiateValidation.handleSubmit}>
          <ModalHeader toggle={() => setModal(!modal)}>
            Negotiate Amount
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>
                Negotiating with <strong>{selectedVendor?.name}</strong>
              </Label>
              <Input
                type="number"
                name="negotiation_cost"
                value={negotiateValidation.values.negotiation_cost}
                onChange={negotiateValidation.handleChange}
                onBlur={negotiateValidation.handleBlur}
                invalid={
                  negotiateValidation.touched.negotiation_cost &&
                  negotiateValidation.errors.negotiation_cost
                }
              />
              <FormFeedback>
                {negotiateValidation.errors.negotiation_cost}
              </FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label>Negotiation End Date</Label>
              <Input
                type="date"
                min={today}
                name="negotiate_end_date"
                value={negotiateValidation.values.negotiate_end_date}
                onChange={negotiateValidation.handleChange}
                onBlur={negotiateValidation.handleBlur}
                invalid={
                  negotiateValidation.touched.negotiate_end_date &&
                  negotiateValidation.errors.negotiate_end_date
                }
              />
              <FormFeedback>
                {negotiateValidation.errors.negotiate_end_date}
              </FormFeedback>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit">
              Submit
            </Button>
            <Button color="secondary" onClick={() => setModal(!modal)}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      {/* Add Task Modal */}
      <Modal
        className="modal-xl modal-dialog-centered"
        isOpen={modalType === "AddTaskModal"}
        toggle={() => changeModal(null)}
      >
        <Form onSubmit={addTaskValidation.handleSubmit}>
          <ModalHeader toggle={() => changeModal(null)}>Add Tasks</ModalHeader>
          <ModalBody>
            <FormGroup>
              {/* Dynamic Task Checklist Rows */}
              <Card>
                <CardBody>
                  <Row>
                    <Col xs="12" md="3">
                      <div className="mb-3">
                        <Label>Task Checklist</Label>
                      </div>
                    </Col>
                    <Col xs="12" md="4">
                      <div className="mb-3">
                        <Label>Documents required for closure of task </Label>
                      </div>
                    </Col>
                    <Col xs="12" md="3">
                      <div className="mb-3">
                        <Label>Estimated Completion Date</Label>
                      </div>
                    </Col>
                  </Row>
                  {tasks1.map((task, index) => (
                    <Row key={index} className="align-items-center">
                      <Col xs="12" md="3">
                        <div className="mb-3">
                          <Input
                            type="text"
                            value={task.task}
                            placeholder="Enter Task"
                            onChange={e =>
                              handleTaskChange(index, "task", e.target.value)
                            }
                          />
                        </div>
                      </Col>
                      <Col xs="12" md="4">
                        <div className="mb-3">
                          <Input
                            type="text"
                            value={task.document_required}
                            placeholder="Enter Document details"
                            onChange={e =>
                              handleTaskChange(
                                index,
                                "document_required",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </Col>
                      <Col xs="12" md="3">
                        <div className="mb-3">
                          <Input
                            type="date"
                            min={today}
                            value={task.estimated_completion_date}
                            placeholder="Enter Estimated Completion Date"
                            onChange={e =>
                              handleTaskChange(
                                index,
                                "estimated_completion_date",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </Col>
                      <Col xs="12" md="2">
                        <Button
                          color="danger"
                          className="mb-3"
                          onClick={() => handleDeleteRow(index)}
                          disabled={tasks1.length === 1}
                        >
                          Delete
                        </Button>
                      </Col>
                    </Row>
                  ))}
                  <Button color="primary" onClick={handleAddRow}>
                    <i className="mdi mdi-plus me-1" />
                    Add Row
                  </Button>
                </CardBody>
              </Card>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Submit
            </Button>
            <Button
              type="button"
              color="secondary"
              onClick={() => changeModal(null)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      {/* Reject Advance Payment Request Modal */}
      <Modal
        isOpen={modalType === "reject_advance_payment_request"}
        toggle={() => changeModal(null)}
      >
        <Form onSubmit={advPaymentRejectionValidation.handleSubmit}>
          <ModalHeader toggle={() => changeModal(null)}>
            Reject Advance Payment
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Reason for Rejection*</Label>
              <Input
                type="textarea"
                name="reject_advance_desc"
                value={advPaymentRejectionValidation.values.reject_advance_desc}
                onChange={advPaymentRejectionValidation.handleChange}
                onBlur={advPaymentRejectionValidation.handleBlur}
                invalid={
                  advPaymentRejectionValidation.touched.reject_advance_desc &&
                  advPaymentRejectionValidation.errors.reject_advance_desc
                }
              />
              <FormFeedback>
                {advPaymentRejectionValidation.errors.reject_advance_desc}
              </FormFeedback>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Submit
            </Button>
            <Button
              type="button"
              color="secondary"
              onClick={() => changeModal(null)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      {/* Accept Payment Request Modal */}
      <Modal
        isOpen={modalType === "accept_payment_request"}
        toggle={() => changeModal(null)}
      >
        <Form onSubmit={acceptPaymentValidation.handleSubmit}>
          <ModalHeader toggle={() => changeModal(null)}>
            Accept Payment Request
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Amount*</Label>
              <Input
                name="paid_amount"
                value={acceptPaymentValidation.values.paid_amount}
                onChange={acceptPaymentValidation.handleChange}
                onBlur={acceptPaymentValidation.handleBlur}
                readOnly
                invalid={
                  acceptPaymentValidation.touched.paid_amount &&
                  acceptPaymentValidation.errors.paid_amount
                }
              />
              <FormFeedback>
                {acceptPaymentValidation.errors.paid_amount}
              </FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label>Payment Date*</Label>
              <Input
                type="date"
                name="payment_date"
                value={acceptPaymentValidation.values.payment_date}
                onChange={acceptPaymentValidation.handleChange}
                onBlur={acceptPaymentValidation.handleBlur}
                invalid={
                  acceptPaymentValidation.touched.payment_date &&
                  acceptPaymentValidation.errors.payment_date
                }
              />
              <FormFeedback>
                {acceptPaymentValidation.errors.payment_date}
              </FormFeedback>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Submit
            </Button>
            <Button
              type="button"
              color="secondary"
              onClick={() => changeModal(null)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
      {/**View Invoice Doc */}
        <Modal className="modal-dialog-centered"  isOpen={modalType === "viewInvoiceDoc"} toggle={() => changeModal()}>
            <ModalHeader toggle={() => changeModal()}>
              Invoice Details
            </ModalHeader>
            <ModalBody style={{backgroundColor: "#f8f9fa"}}>
              <div className="mb-4">
                <Card className="h-100">
                  <CardBody>
                <div className="table-responsive">
                  <table className="table  mb-0">
                    <tbody>
                    {/* Invoice Number */}
                    <tr>
                      <th style={{ whiteSpace: "nowrap" }}>Invoice Number</th>
                      <td>{invoice.invoice_number}</td>
                    </tr>
                    {/* Invoice Date */}
                    <tr>
                      <th style={{ whiteSpace: "nowrap" }}>Invoice Date</th>
                      <td>
                        {invoice.invoice_date?changeDateFormat(invoice.invoice_date):"--"}
                      </td>
                    </tr>
                
                    {/* Taxable Amount */}
                    <tr>
                      <th style={{ whiteSpace: "nowrap" }}>Taxable Amount</th>
                      <td>
                        {invoice.taxable_amount}
                      </td>
                    </tr>
                    {/* GST Amount */}
                    <tr>
                      <th style={{ whiteSpace: "nowrap" }}>GST Amount</th>
                      <td>
                          {invoice.gst_amount}
                      </td>
                    </tr>
                    {/*Invoice Amount */}
                    <tr>
                      <th style={{ whiteSpace: "nowrap" }}>Invoice Amount</th>
                      <td>
                        <span >
                          {invoice.invoice_amount}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th style={{ whiteSpace: "nowrap" }}>Invoice Document</th>
                        <td>
                          <div style={{ height: invoice.invoice_documentview_path ? "100px" : "20px", overflowY: "hidden" }}>
                            <div style={{ 
                              display: "flex", 
                              overflowX: "auto",
                              paddingBottom: "10px",
                              height: "100%",
                              alignItems: "flex-start"
                            }}>
       
                            {invoice.invoice_documentview_path && (
                              <div
                                style={{
                                  flexShrink: 0,
                                  width: "50px",
                                  height: "50px",
                                  marginRight: "10px",
                                  overflow: "hidden",
                                  borderRadius: "15px",
                                }}
                              >
                                <a
                                  href={invoice.invoice_documentview_path}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                <img
                                  src={invoice.invoice_documentview_path}
                                  alt={`Invoice Doc ${invoice.milestone_id}`}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                  />
                                </a>
                              </div>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                  </CardBody>
                </Card>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                color="secondary"
                onClick={() => changeModal()}
              >
                Cancel
              </Button>
            </ModalFooter>
        </Modal>
      {/* Add Payment Modal */}
      <Modal
        isOpen={modalType === "addPayment"}
        toggle={() => changeModal(null)}
      >
        <Form onSubmit={addPaymentValidation.handleSubmit}>
          <ModalHeader toggle={() => changeModal(null)}>Payment</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Milestone</Label>
              <Input
                type="select"
                name="milestone_id"
                value={addPaymentValidation.values.milestone_id}
                onChange={handleMilestoneChange}
                onBlur={addPaymentValidation.handleBlur}
                invalid={
                  addPaymentValidation.touched.milestone_id &&
                  addPaymentValidation.errors.milestone_id
                }
              >
                <option value="">Select Milestone</option>
                {milestoneOptions?.map(ms =>(
                  <option key={ms.id} value={ms.id}>{ms.title}{ms.pending_amount===0?` (Paid)`:` (Pending Amount: ${ms.pending_amount})`}</option>
                ))}
              </Input>
              <FormFeedback>
                {addPaymentValidation.errors.milestone_id}
              </FormFeedback>
            </FormGroup>
            {selectedMilestoneAmt!==0&&(
            <><FormGroup>
                <Label>Amount</Label>
                <Input
                  name="paid_amount"
                  value={addPaymentValidation.values.paid_amount}
                  onChange={addPaymentValidation.handleChange}
                  onBlur={addPaymentValidation.handleBlur}
                  invalid={addPaymentValidation.touched.paid_amount &&
                    addPaymentValidation.errors.paid_amount} />
                <FormFeedback>
                  {addPaymentValidation.errors.paid_amount}
                </FormFeedback>
              </FormGroup><FormGroup>
                  <Label>Payment Date</Label>
                  <Input
                    type="date"
                    name="payment_date"
                    value={addPaymentValidation.values.payment_date}
                    onChange={addPaymentValidation.handleChange}
                    onBlur={addPaymentValidation.handleBlur}
                    invalid={addPaymentValidation.touched.payment_date &&
                      addPaymentValidation.errors.payment_date} />
                  <FormFeedback>
                    {addPaymentValidation.errors.payment_date}
                  </FormFeedback>
                </FormGroup>
                <FormGroup>
                  <Label>Description</Label>
                  <Input
                    name="request_advance_desc"
                    value={addPaymentValidation.values.request_advance_desc}
                    onChange={addPaymentValidation.handleChange}
                    onBlur={addPaymentValidation.handleBlur}
                    invalid={addPaymentValidation.touched.request_advance_desc &&
                      addPaymentValidation.errors.request_advance_desc} />
                  <FormFeedback>
                    {addPaymentValidation.errors.request_advance_desc}
                  </FormFeedback>
                </FormGroup>
                      </>
                )}
                {selectedMilestoneAmt===0&&(
                  <div className="alert alert-danger mt-2">
                    Milestone is already paid
                  </div>
                )}
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Submit
            </Button>
            <Button
              type="button"
              color="secondary"
              onClick={() => changeModal(null)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      {/* Rework Modal */}
      <Modal isOpen={modalType === "rework"} toggle={() => changeModal(null)}>
        <Form onSubmit={reworkValidation.handleSubmit}>
          <ModalHeader toggle={() => changeModal(null)}>
            Rework Needed
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Rework Description</Label>
              <Input
                type="textarea"
                name="rework_reason"
                value={reworkValidation.values.rework_reason}
                onChange={reworkValidation.handleChange}
                onBlur={reworkValidation.handleBlur}
                invalid={
                  reworkValidation.touched.rework_reason &&
                  reworkValidation.errors.rework_reason
                }
              />
              <FormFeedback>
                {reworkValidation.errors.rework_reason}
              </FormFeedback>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Submit
            </Button>
            <Button
              type="button"
              color="secondary"
              onClick={() => changeModal(null)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      {/* Close Modal */}
      <Modal isOpen={modalType === "close"} toggle={() => changeModal(null)}>
        <Form onSubmit={closeValidation.handleSubmit}>
          <ModalHeader toggle={() => changeModal(null)}>
            RFQ Closure
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>
                <strong>
                  Total Remaining Amount (including Fixed Deposit):
                </strong>{" "}
                {rfqDetail.new_final_remaining_amount
                  ? formatNumberWithCommas(rfqDetail.new_final_remaining_amount)
                  : "--"}
              </Label>
              <br></br>
              <br></br>
              <Label>Paid Amount</Label>
              <Input
                name="paid_amount"
                value={closeValidation.values.paid_amount}
                onChange={closeValidation.handleChange}
                onBlur={closeValidation.handleBlur}
                invalid={
                  closeValidation.touched.paid_amount &&
                  closeValidation.errors.paid_amount
                }
              />
              <FormFeedback>{closeValidation.errors.paid_amount}</FormFeedback>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Submit
            </Button>
            <Button
              type="button"
              color="secondary"
              onClick={() => changeModal(null)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      {/*PAYMENT DETAILS MODAL*/}
      <Modal
        isOpen={modalType === "paymentdetails"}
        toggle={() => changeModal()}
      >
        <Form onSubmit={paymentDetailsValidation.handleSubmit}>
          <ModalHeader toggle={() => changeModal()}>
            Payment Details
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Security Deposit Amount</Label>
              <Input
                name="security_deposit_amount"
                value={paymentDetailsValidation.values.security_deposit_amount}
                onChange={paymentDetailsValidation.handleChange}
                onBlur={paymentDetailsValidation.handleBlur}
                invalid={
                  paymentDetailsValidation.touched.security_deposit_amount &&
                  paymentDetailsValidation.errors.security_deposit_amount
                }
              />
              <FormFeedback>
                {paymentDetailsValidation.errors.security_deposit_amount}
              </FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label>Advance Payment Amount</Label>
              <Input
                name="advance_payment_amount"
                value={paymentDetailsValidation.values.advance_payment_amount}
                onChange={paymentDetailsValidation.handleChange}
                onBlur={paymentDetailsValidation.handleBlur}
                invalid={
                  paymentDetailsValidation.touched.advance_payment_amount &&
                  paymentDetailsValidation.errors.advance_payment_amount
                }
              />
              <FormFeedback>
                {paymentDetailsValidation.errors.advance_payment_amount}
              </FormFeedback>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Submit
            </Button>
            <Button
              type="button"
              color="secondary"
              onClick={() => changeModal()}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      {/* Support Docs Table Modal */}
      <Modal
        isOpen={modalType === "supportDocsTable"}
        toggle={() => changeModal()}
      >
        <Form>
          <ModalHeader toggle={() => changeModal()}>
            Support Docs Table
          </ModalHeader>
          <ModalBody>
            <Table bordered>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Support Docs</th>
                </tr>
              </thead>
              <tbody>
                {documents?.map((task, index) => (
                  <tr key={index}>
                    <td>
                      {task.created_at
                        ? changeDateFormat(
                            new Date(task.created_at)
                              .toISOString()
                              .split("T")[0]
                          )
                        : "--"}
                    </td>

                    <td>
                      {task.view_path ? (
                        <a
                          key={index}
                          href={task.view_path}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={task.view_path}
                            alt={`Image ${index}`}
                            style={{
                              width: "50px",
                              height: "auto",
                              marginRight: "5px",
                            }}
                          />
                        </a>
                      ) : (
                        "--"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            {/*<Button type="submit" color="primary">
                Save Changes
              </Button>*/}
            <Button color="secondary" onClick={() => changeModal()}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
      {/* Submission Proof Table Modal */}
      <Modal
        isOpen={modalType === "submissionProofTable"}
        toggle={() => changeModal()}
      >
        <Form>
          <ModalHeader toggle={() => changeModal()}>
            Submission Proof Table
          </ModalHeader>
          <ModalBody>
            <Table bordered>
              {console.log("submission proof", documents)}
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Submission Proof</th>
                </tr>
              </thead>
              <tbody>
                {documents?.map((doc, index) => (
                  <tr key={index}>
                    <td>
                      {doc.created_at
                        ? changeDateFormat(
                            new Date(doc.created_at).toISOString().split("T")[0]
                          )
                        : "--"}
                    </td>
                    <td>
                      {doc.view_path ? (
                        <a
                          key={index}
                          href={doc.view_path}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={doc.view_path}
                            alt={`Image ${index}`}
                            style={{
                              width: "50px",
                              height: "auto",
                              marginRight: "5px",
                            }}
                          />
                        </a>
                      ) : (
                        "--"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            {/*<Button type="submit" color="primary">
                Save Changes
              </Button>*/}
            <Button color="secondary" onClick={() => changeModal()}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
      {/* Work Progress Table Modal */}
      <Modal
        isOpen={modalType === "workProgressTable"}
        toggle={() => changeModal()}
      >
        <Form>
          <ModalHeader toggle={() => changeModal()}>
            Work Progress and Supporting Docs
          </ModalHeader>
          <ModalBody>
            <Table bordered className="table table-striped mb-0">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Progress (in %)</th>
                  <th>Description</th>
                  <th>Supporting Docs</th>
                </tr>
              </thead>
              <tbody>
                {documents?.map((task, index) => {
                  const taskPics = pics.filter(pic => pic.work_progress_id === task.id)
                  console.log("taskPics",taskPics)
                  return(
                    <>
                      <tr key={index}>
                        <td>
                          {task.created_at?changeDateFormat(new Date(task.created_at).toISOString().split("T")[0]):"--"}
                        </td>
                        <td>
                          {task.work_progress || "--"}
                        </td>
                        <td>
                          {task.work_description || "--"}
                        </td>
                        <td>
                          <div style={{ display: "flex", flexWrap: "wrap" }}>
                          {taskPics.map((taskpic, i) => (
                            <div
                                key={i}
                                style={{
                                  flexShrink: 0,
                                  width: "50px",
                                  height: "50px",
                                  marginRight: i % 2 === 0 ? "10px" : "0", // Add margin only to the first item in each row
                                  marginBottom: "10px",
                                  overflow: "hidden",
                                  borderRadius: "15px",
                                }}
                              >
                                <a
                                  key={i}
                                  href={taskpic.view_path}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    src={taskpic.view_path}
                                    alt={`Image ${i}`}
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      borderRadius: "15px",
                                    }}
                                  />
                                </a>
                              </div>
                          ))}
                          </div>
                        </td>
                      </tr>
                    </>
                  )
                })}
              </tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            {/*<Button type="submit" color="primary">
                Save Changes
              </Button>*/}
            <Button color="secondary" onClick={() => changeModal()}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      {/*Milestones MODAL*/}
      <Modal
        className="modal-xl modal-dialog-centered"
        isOpen={modalType === "milestones"}
        toggle={() => changeModal()}
      >
        <Form onSubmit={milestoneValidation.handleSubmit}>
          <ModalHeader toggle={() => changeModal()}>Milestones</ModalHeader>
          <ModalBody>
            <Card>
              <CardBody>
                <Row>
                  <div className="mb-3">
                    <h6>Payment Summary:</h6>
                    <div className="d-flex justify-content-between">
                      <div>
                        <strong>Total Allocated:</strong> {paymentTotals.total}
                      </div>
                      <div>
                        <strong>Total Amount:</strong>{" "}
                        {paymentTotals.requiredTotal}
                      </div>
                      <div
                        className={
                          parseFloat(paymentTotals.remaining) !== 0
                            ? "text-danger"
                            : "text-success"
                        }
                      >
                        <strong>Remaining:</strong> {paymentTotals.remaining}
                      </div>
                    </div>

                    {/* Display payment total error */}
                    {milestoneValidation.errors.milestones &&
                      milestoneValidation.errors.milestones ===
                        "Total payment amount must match the RFQ remaining amount" && (
                        <div className="alert alert-danger mt-2">
                          {milestoneValidation.errors.milestones}
                          <div className="mt-1">
                            Current total: {paymentTotals.total}, Required:{" "}
                            {paymentTotals.requiredTotal}
                          </div>
                        </div>
                      )}
                  </div>
                  {/* Add this inside CardBody */}
                  <div className="mb-3">
                    <h6>Task Assignment Status:</h6>
                    <div className="d-flex flex-wrap gap-2">
                      {taskOptions.map(task => {
                        const isAssigned =
                          milestoneValidation.values.milestones.some(m =>
                            m.task_ids.includes(task.value)
                          )

                        return (
                          <span
                            className={`badge ${
                              isAssigned ? "bg-success" : "bg-danger"
                            }`}
                            key={task.value}
                          >
                            {task.label}:{" "}
                            {isAssigned ? "Assigned" : "Unassigned"}
                          </span>
                        )
                      })}
                    </div>
                    {typeof milestoneValidation?.errors?.milestones ===
                      "string" && (
                      <div className="alert alert-danger mt-2">
                        {milestoneValidation.errors.milestones}
                      </div>
                    )}
                  </div>
                  <Table
                    style={{
                      whiteSpace: "nowrap",
                      //tableLayout: "auto",
                      //display: "inline-block",
                      border: "none",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            left: 0,
                            zIndex: 2,
                            background: "white",
                            border: "none",
                          }}
                        >
                          Milestone no.
                        </th>
                        <th
                          style={{
                            left: 0,
                            zIndex: 2,
                            background: "white",
                            border: "none",
                          }}
                        >
                          Title
                        </th>
                        <th
                          style={{
                            left: 0,
                            zIndex: 2,
                            background: "white",
                            border: "none",
                          }}
                        >
                          Tasks
                        </th>
                        <th
                          style={{
                            left: 0,
                            zIndex: 2,
                            background: "white",
                            border: "none",
                          }}
                        >
                          Milestone Budget Amount
                        </th>
                        <th
                          style={{
                            left: 0,
                            zIndex: 2,
                            background: "white",
                            border: "none",
                          }}
                        >
                          Advance Payment
                        </th>
                        
                        <th
                          style={{
                            left: 0,
                            zIndex: 2,
                            background: "white",
                            border: "none",
                          }}
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {milestoneValidation.values.milestones.map(
                        (milestone, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                left: 0,
                                background: "white",
                                zIndex: 2,
                                border: "none",
                              }}
                            >
                              <Label>Milestone {index + 1}</Label>
                            </td>
                            <td
                              style={{
                                left: 0,
                                background: "white",
                                zIndex: 2,
                                border: "none",
                              }}
                            >
                              <Input
                                id={`title-${index}`}
                                name={`milestones[${index}].title`}
                                value={milestone.title}
                                onChange={milestoneValidation.handleChange}
                                onBlur={milestoneValidation.handleBlur}
                              />
                              {milestoneValidation.touched.milestones?.[index]
                                ?.title &&
                                milestoneValidation.errors.milestones?.[index]
                                  ?.title && (
                                  <div
                                    style={{
                                      color: "#f46a6a",
                                      fontSize: "80%",
                                    }}
                                    type="invalid-feedback d-block"
                                  >
                                    {
                                      milestoneValidation.errors.milestones[
                                        index
                                      ].title
                                    }
                                  </div>
                                )}
                            </td>
                            <td
                              style={{
                                left: 0,
                                background: "white",
                                zIndex: 2,
                                border: "none",
                              }}
                            >
                              <Select
                                isMulti
                                options={taskOptions.filter(task => {
                                  const allSelected =
                                    milestoneValidation.values.milestones.flatMap(
                                      m => m.task_ids
                                    )
                                  return (
                                    !allSelected.includes(task.value) ||
                                    milestone.task_ids.includes(task.value)
                                  )
                                })}
                                value={taskOptions.filter(option =>
                                  milestone.task_ids.includes(option.value)
                                )}
                                onChange={selected =>
                                  milestoneValidation.setFieldValue(
                                    `milestones[${index}].task_ids`,
                                    selected.map(option => option.value)
                                  )
                                }
                                onBlur={() =>
                                  milestoneValidation.setFieldTouched(
                                    `milestones[${index}].task_ids`,
                                    true
                                  )
                                }
                              />
                              {milestoneValidation.touched.milestones?.[index]
                                ?.task_ids &&
                                milestoneValidation.errors.milestones?.[index]
                                  ?.task_ids && (
                                  <div className="invalid-feedback d-block">
                                    {
                                      milestoneValidation.errors.milestones[
                                        index
                                      ].task_ids
                                    }
                                  </div>
                                )}
                            </td>
                            <td
                              style={{
                                left: 0,
                                background: "white",
                                zIndex: 2,
                                border: "none",
                              }}
                            >
                              <Input
                                id={`payment-${index}`}
                                name={`milestones[${index}].payment_amount`}
                                value={milestone.payment_amount}
                                onChange={milestoneValidation.handleChange}
                                onBlur={milestoneValidation.handleBlur}
                              />
                              {milestoneValidation.touched.milestones?.[index]
                                ?.payment_amount &&
                                milestoneValidation.errors.milestones?.[index]
                                  ?.payment_amount && (
                                  <div
                                    style={{
                                      color: "#f46a6a",
                                      fontSize: "80%",
                                    }}
                                    type="invalid-feedback d-block"
                                  >
                                    {
                                      milestoneValidation.errors.milestones[
                                        index
                                      ].payment_amount
                                    }
                                  </div>
                                )}
                            </td>
                            <td
                              style={{
                                left: 0,
                                background: "white",
                                zIndex: 2,
                                border: "none",
                              }}
                            >
                              <Input
                                id={`advance_payment-${index}`}
                                name={`milestones[${index}].advance_payment`}
                                value={milestone.advance_payment}
                                onChange={milestoneValidation.handleChange}
                                onBlur={milestoneValidation.handleBlur}
                              />
                              {milestoneValidation.touched.milestones?.[index]
                                ?.advance_payment &&
                                milestoneValidation.errors.milestones?.[index]
                                  ?.advance_payment && (
                                  <div
                                    style={{
                                      color: "#f46a6a",
                                      fontSize: "80%",
                                    }}
                                    type="invalid-feedback d-block"
                                  >
                                    {
                                      milestoneValidation.errors.milestones[
                                        index
                                      ].advance_payment
                                    }
                                  </div>
                                )}
                            </td>
                            <td
                              style={{
                                left: 0,
                                background: "white",
                                zIndex: 2,
                                border: "none",
                              }}
                            >
                              <Button
                                color="danger"
                                className="mb-3"
                                disabled={
                                  milestoneValidation.values.milestones
                                    .length === 1
                                }
                                title={
                                  milestoneValidation.values.milestones
                                    .length === 1
                                    ? "At least one milestone is required"
                                    : "Delete milestone"
                                }
                                onClick={() =>
                                  handleDeleteRowForMilestone(index)
                                }
                              >
                                Delete
                              </Button>
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                </Row>

                <Button color="primary" onClick={handleAddRowForMilestone}>
                  <i className="mdi mdi-plus me-1" />
                  Add Row
                </Button>
              </CardBody>
            </Card>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Save Changes
            </Button>
            <Button
              type="button"
              color="secondary"
              onClick={() => changeModal()}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>


      {/*Add New Milestones MODAL*/}
      <Modal
        className="modal-xl modal-dialog-centered"
        isOpen={modalType === "addNewMilestones"}
        toggle={() => changeModal()}
      >
        <Form onSubmit={addNewMilestoneValidation.handleSubmit}>
          <ModalHeader toggle={() => changeModal()}>Milestones</ModalHeader>
          <ModalBody>
            <Card>
              <CardBody>
                
                <Row>
                  <Row>
                
              <Col xs="12" md="4">
              <Label>Milestone Title</Label>
              <Input
                name="milestone_title"
                value={addNewMilestoneValidation.values.milestone_title}
                onChange={addNewMilestoneValidation.handleChange}
                onBlur={addNewMilestoneValidation.handleBlur}
                invalid={
                  addNewMilestoneValidation.touched.milestone_title &&
                  addNewMilestoneValidation.errors.milestone_title
                }
              />
              <FormFeedback>
                {addNewMilestoneValidation.errors.milestone_title}
              </FormFeedback>
            </Col>
            <Col xs="12" md="4">
              <Label>Milestone Budget Amount</Label>
              <Input
                name="milestone_amount"
                value={addNewMilestoneValidation.values.milestone_amount}
                onChange={addNewMilestoneValidation.handleChange}
                onBlur={addNewMilestoneValidation.handleBlur}
                invalid={
                  addNewMilestoneValidation.touched.milestone_amount &&
                  addNewMilestoneValidation.errors.milestone_amount
                }
              />
              <FormFeedback>
                {addNewMilestoneValidation.errors.milestone_amount}
              </FormFeedback>
            </Col>                
              <Col xs="12" md="4">
              <Label>Advance Payment</Label>
              <Input
                name="advance_payment"
                value={addNewMilestoneValidation.values.advance_payment}
                onChange={addNewMilestoneValidation.handleChange}
                onBlur={addNewMilestoneValidation.handleBlur}
                invalid={
                  addNewMilestoneValidation.touched.advance_payment &&
                  (addNewMilestoneValidation.values.advance_payment>addNewMilestoneValidation.values.milestone_amount ||addNewMilestoneValidation.errors.advance_payment)
                }
              />
              <FormFeedback>
                {addNewMilestoneValidation.errors.advance_payment}
              </FormFeedback>
            </Col>
            </Row>
                  <Table
                    style={{
                      whiteSpace: "nowrap",
                      //tableLayout: "auto",
                      //display: "inline-block",
                      border: "none",
                      marginTop:"15px"
                    }}
                  >
                    <thead>
                      <tr style={{border:"none"}}>
                      <th
                      style={{
                            left: 0,
                            zIndex: 2,
                            background: "white",
                            border: "none",
                          }}>
                        Task Checklist
                      </th>
                      <th
                      style={{
                            left: 0,
                            zIndex: 2,
                            background: "white",
                            border: "none",
                          }}
                      >
                        Documents required for closure of task 
                      </th>
                      <th
                      style={{
                            left: 0,
                            zIndex: 2,
                            background: "white",
                            border: "none",
                          }}>
                            Estimated Completion Date
                      </th>
                      </tr>
                    </thead>
                    <tbody>
                  {tasks1.map((task, index) => (
                    <tr key={index} >
                      <td style={{border:"none"}}>
                        <Input
                          type="text"
                          value={task.task}
                          placeholder="Enter Task"
                          onChange={e =>
                            handleTaskForMS(index, "task", e.target.value)
                          }
                        />
                      </td>
                      <td style={{border:"none"}}>
                        <Input
                          type="text"
                          value={task.document_required}
                          placeholder="Enter Document details"
                          onChange={e =>
                            handleTaskForMS(
                              index,
                              "document_required",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td style={{border:"none"}}>
                        <Input
                            type="date"
                            min={today}
                            value={task.estimated_completion_date}
                            placeholder="Enter Estimated Completion Date"
                            onChange={e =>
                              handleTaskForMS(
                                index,
                                "estimated_completion_date",
                                e.target.value
                              )
                            }
                          />
                      </td>
                      <td style={{border:"none"}}>
                        <Button
                          color="danger"
                          className="mb-3"
                          onClick={() => handleDeleteRow(index)}
                          disabled={tasks1.length === 1}
                        >
                          <i className="mdi mdi-trash-can-outline"/>
                          &nbsp;
                          Delete Task
                        </Button>
                      </td>
                    </tr>
                  ))}</tbody>
                  </Table>
                  </Row>
                  <Button color="primary" onClick={handleAddRow}>
                    <i className="mdi mdi-plus me-1" />
                    Add Task
                  </Button>
              </CardBody>
            </Card>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Save Changes
            </Button>
            <Button
              type="button"
              color="secondary"
              onClick={() => changeModal()}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  )
}

export default ViewRfqQuotes
